module.exports = __webpack_public_path__ + "img/immersive-h5.0123279a.webp";